import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SiteAction } from '../../actions/SiteAction';
import { RayForm } from '../../components/common';
import { EditSaveCancelBar } from '../common/Buttons';
import { useBatchEdit } from '../../hooks/useBatchEdit';
import { SpecialityTypes } from '../../config/RayCodes';
import { CountryCode } from '../../config';
import { NoRecord } from '../../pages/HomePage';
import { Translate as t } from '../../config/Translate';

const SITE_FIELDS = ['sitename', 'speciality', 'tel', 'fax', 'email', 'hp', 'address', 'zipcode', 'country', 'website'];
const toDraft = (s) => SITE_FIELDS.reduce((o, k) => ({ ...o, [k]: s?.[k] }), {});

const SiteInfo = ({ siteId, siteReducer, GetSite, UpdateSiteInfo, editable, siteInfo, cancelcallback = null, showTitle = false, onlyShowHasVal = false, nocard = false }) => {
    const isAdmin = location.pathname.toLowerCase().startsWith('/admin/');
    const site = siteReducer ?? siteInfo;
    const { draft, editing, saving, errors, formKey, onChange, onEdit, onSave, onCancel } = useBatchEdit({
        source: site,
        toDraft,
        save: (changed) => UpdateSiteInfo(site._id, changed),
        editable: !!editable,
        entry: 'header',
        onClose: cancelcallback
    });

    useEffect(() => {
        if (siteId)
            GetSite(siteId);
    }, []);

    const canEditFields = editing;

    const form_controls = [
        {
            title: "", items: [
                {
                    type: "input", name: "sitename", label: t('site.field.siteName'),
                    viewLinkPath: isAdmin ? "/Admin/AdminSiteInfo/" : "/Site/",
                    viewLinkUseId: site && site.siteId,
                    extra: site,
                    val: draft.sitename, required: true, isEditable: canEditFields
                },
                { type: "select", name: "speciality", label: t('site.field.specialty'), val: draft.speciality, list: SpecialityTypes, isEditable: canEditFields },
                { type: "tel", name: "tel", label: t('common.field.tel'), val: draft.tel, isEditable: canEditFields },
                { type: "tel", name: "fax", label: t('common.field.fax'), val: draft.fax, isEditable: canEditFields },
                { type: "email", name: "email", label: t('common.field.email'), val: draft.email, isEditable: canEditFields },
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: draft.hp, isEditable: canEditFields },
                { type: "input", name: "address", label: t('common.field.address'), size: 12, val: draft.address, isEditable: canEditFields },
                { type: "tel", name: "zipcode", label: t('common.field.zipCode'), val: draft.zipcode, isEditable: canEditFields },
                { type: "select", name: "country", label: t('common.field.country'), val: draft.country, list: CountryCode, isEditable: canEditFields },
                { type: "input", name: "website", label: t('common.field.homepage'), val: draft.website, size: 12, isEditable: canEditFields }
            ]
        }
    ]

    const getControl = () => {
        let list = []
        if (!editable && !showTitle) {
            list = [{ title: "", items: form_controls[0].items.filter(x => x.name != "sitename") }];
        } else {
            list = form_controls;
        }

        if (onlyShowHasVal && !editable) {
            list = [{ title: "", items: form_controls[0].items.filter(x => x.val) }];
        }
        return list;
    }

    return <>
        {site && <>
            {site._id && <RayForm
                key={formKey}
                nocard={nocard}
                controls={getControl()}
                handleChangeData={onChange}
                errors={errors} />}
            {site._id && <div className="ps-1 pe-1 mb-1">
                <EditSaveCancelBar canEdit={!!editable} editing={editing} onEdit={onEdit} onSave={() => onSave(form_controls)} onCancel={onCancel} saving={saving} />
            </div>}
            {!site._id && <div className='section'><NoRecord title={t('common.message.notExists')} contents={t('site.message.error.siteInformationDoesNotExistNow')} /></div>}
        </>}
    </>
};

const mapState = (state) => {
    const siteReducer = state.SiteReducer.site;
    return { siteReducer };
}

const mapDispatch = dispatch => ({
    UpdateSiteInfo: (_id, data) => dispatch(SiteAction.UpdateSiteInfo(_id, data)),
    GetSite: (_id) => dispatch(SiteAction.GetSite(_id))
})

export default connect(mapState, mapDispatch)(SiteInfo);